import * as React from "react";

const BreadcrumbClassifications = ({ data }) => {
  const disciplines = data.content.categories.filter(
    (category) => category.category === "DISCIPLINAS"
  );

  const tags = data.content.tags;

  return (
    <ol className="breadcrumb-classifications eva-color-inst-500 eva-text-bold eva-margin-bottom-1 d-inline-flex">
      <li>Fichas de recomposição</li>
      {!!disciplines.length && <li>{disciplines[0].name}</li>}
      {!!tags.length && <li>{tags[0].tag}</li>}
    </ol>
  );
};

export default BreadcrumbClassifications;
